// When the user scrolls the page, execute myFunction
window.addEventListener("scroll", SetupSticky);
window.addEventListener("scroll", WaypointSetup);

let sections = document.getElementsByClassName(
	"tech-section-scrolling-section"
);
let header_buttons = document.getElementsByClassName("tech-menu-item");

function sleep(ms) {
	return new Promise((resolve) => setTimeout(resolve, ms));
}

// Add the sticky class to the header when you reach its scroll position. Remove "sticky-tech-menu" when you leave the scroll position. OG
function SetupSticky() {
	if (window.scrollY > 1580) {
		document
			.getElementsByClassName("tech-section-sticky-header")[0]
			.classList.add("sticky-tech-menu");
		document
			.getElementsByClassName("tech-section-header-container")[0]
			.classList.add("sticky-tech-menu-before");
	} else {
		document
			.getElementsByClassName("tech-section-sticky-header")[0]
			.classList.remove("sticky-tech-menu");
		document
			.getElementsByClassName("tech-section-header-container")[0]
			.classList.remove("sticky-tech-menu-before");
	}
	//Sleep is there becaues it was running 700req per scroll, which is kinda dumb.
	sleep(500);
}

function WaypointSetup() {
	var section1 = new Waypoint({
		element: sections[0],
		handler: function () {
			// console.log("Section 1 Has been Scrolled");
			header_buttons[0].classList.add("highlighted");
			header_buttons[1].classList.remove("highlighted");
			header_buttons[2].classList.remove("highlighted");
			header_buttons[3].classList.remove("highlighted");
			header_buttons[4].classList.remove("highlighted");
			header_buttons[5].classList.remove("highlighted");
			header_buttons[6].classList.remove("highlighted");
			header_buttons[7].classList.remove("highlighted");
			document
				.getElementById("section-1")
				.classList.add("section-animated-enter");
			document
				.getElementById("section-1")
				.classList.remove("section-animated-exit");
			document
				.getElementById("section-2")
				.classList.remove("section-animated-enter");
			document
				.getElementById("section-2")
				.classList.add("section-animated-exit");
			document
				.getElementById("section-3")
				.classList.remove("section-animated-enter");
			document
				.getElementById("section-3")
				.classList.add("section-animated-exit");
			document
				.getElementById("section-4")
				.classList.remove("section-animated-enter");
			document
				.getElementById("section-4")
				.classList.add("section-animated-exit");
			document
				.getElementById("section-5")
				.classList.remove("section-animated-enter");
			document
				.getElementById("section-5")
				.classList.add("section-animated-exit");
			document
				.getElementById("section-6")
				.classList.remove("section-animated-enter");
			document
				.getElementById("section-6")
				.classList.add("section-animated-exit");
			document
				.getElementById("section-7")
				.classList.remove("section-animated-enter");
			document
				.getElementById("section-7")
				.classList.add("section-animated-exit");
			document
				.getElementById("section-8")
				.classList.remove("section-animated-enter");
			document
				.getElementById("section-8")
				.classList.add("section-animated-exit");
		},
		offset: 500,
	});
	var section2 = new Waypoint({
		element: sections[1],
		handler: function () {
			// console.log("Section 2 Has been Scrolled");
			header_buttons[0].classList.remove("highlighted");
			header_buttons[1].classList.add("highlighted");
			header_buttons[2].classList.remove("highlighted");
			header_buttons[3].classList.remove("highlighted");
			header_buttons[4].classList.remove("highlighted");
			header_buttons[5].classList.remove("highlighted");
			header_buttons[6].classList.remove("highlighted");
			header_buttons[7].classList.remove("highlighted");
			document
				.getElementById("section-1")
				.classList.remove("section-animated-enter");
			document
				.getElementById("section-1")
				.classList.add("section-animated-exit");
			document
				.getElementById("section-2")
				.classList.add("section-animated-enter");
			document
				.getElementById("section-2")
				.classList.remove("section-animated-exit");
			document
				.getElementById("section-3")
				.classList.remove("section-animated-enter");
			document
				.getElementById("section-3")
				.classList.add("section-animated-exit");
			document
				.getElementById("section-4")
				.classList.remove("section-animated-enter");
			document
				.getElementById("section-4")
				.classList.add("section-animated-exit");
			document
				.getElementById("section-5")
				.classList.remove("section-animated-enter");
			document
				.getElementById("section-5")
				.classList.add("section-animated-exit");
			document
				.getElementById("section-6")
				.classList.remove("section-animated-enter");
			document
				.getElementById("section-6")
				.classList.add("section-animated-exit");
			document
				.getElementById("section-7")
				.classList.remove("section-animated-enter");
			document
				.getElementById("section-7")
				.classList.add("section-animated-exit");
			document
				.getElementById("section-8")
				.classList.remove("section-animated-enter");
			document
				.getElementById("section-8")
				.classList.add("section-animated-exit");
		},
		offset: 500,
	});
	var section3 = new Waypoint({
		element: sections[2],
		handler: function () {
			// console.log("Section 3 Has been Scrolled");
			header_buttons[0].classList.remove("highlighted");
			header_buttons[1].classList.remove("highlighted");
			header_buttons[2].classList.add("highlighted");
			header_buttons[3].classList.remove("highlighted");
			header_buttons[4].classList.remove("highlighted");
			header_buttons[5].classList.remove("highlighted");
			header_buttons[6].classList.remove("highlighted");
			header_buttons[7].classList.remove("highlighted");
			document
				.getElementById("section-1")
				.classList.remove("section-animated-enter");
			document
				.getElementById("section-1")
				.classList.add("section-animated-exit");
			document
				.getElementById("section-2")
				.classList.remove("section-animated-enter");
			document
				.getElementById("section-2")
				.classList.add("section-animated-exit");
			document
				.getElementById("section-3")
				.classList.add("section-animated-enter");
			document
				.getElementById("section-3")
				.classList.remove("section-animated-exit");
			document
				.getElementById("section-4")
				.classList.remove("section-animated-enter");
			document
				.getElementById("section-4")
				.classList.add("section-animated-exit");
			document
				.getElementById("section-5")
				.classList.remove("section-animated-enter");
			document
				.getElementById("section-5")
				.classList.add("section-animated-exit");
			document
				.getElementById("section-6")
				.classList.remove("section-animated-enter");
			document
				.getElementById("section-6")
				.classList.add("section-animated-exit");
			document
				.getElementById("section-7")
				.classList.remove("section-animated-enter");
			document
				.getElementById("section-7")
				.classList.add("section-animated-exit");
			document
				.getElementById("section-8")
				.classList.remove("section-animated-enter");
			document
				.getElementById("section-8")
				.classList.add("section-animated-exit");
		},
		offset: 500,
	});
	var section4 = new Waypoint({
		element: sections[3],
		handler: function () {
			// console.log("Section 4 Has been Scrolled");
			header_buttons[0].classList.remove("highlighted");
			header_buttons[1].classList.remove("highlighted");
			header_buttons[2].classList.remove("highlighted");
			header_buttons[3].classList.add("highlighted");
			header_buttons[4].classList.remove("highlighted");
			header_buttons[5].classList.remove("highlighted");
			header_buttons[6].classList.remove("highlighted");
			header_buttons[7].classList.remove("highlighted");
			document
				.getElementById("section-1")
				.classList.remove("section-animated-enter");
			document
				.getElementById("section-1")
				.classList.add("section-animated-exit");
			document
				.getElementById("section-2")
				.classList.remove("section-animated-enter");
			document
				.getElementById("section-2")
				.classList.add("section-animated-exit");
			document
				.getElementById("section-3")
				.classList.remove("section-animated-enter");
			document
				.getElementById("section-3")
				.classList.add("section-animated-exit");
			document
				.getElementById("section-4")
				.classList.add("section-animated-enter");
			document
				.getElementById("section-4")
				.classList.remove("section-animated-exit");
			document
				.getElementById("section-5")
				.classList.remove("section-animated-enter");
			document
				.getElementById("section-5")
				.classList.add("section-animated-exit");
			document
				.getElementById("section-6")
				.classList.remove("section-animated-enter");
			document
				.getElementById("section-6")
				.classList.add("section-animated-exit");
			document
				.getElementById("section-7")
				.classList.remove("section-animated-enter");
			document
				.getElementById("section-7")
				.classList.add("section-animated-exit");
			document
				.getElementById("section-8")
				.classList.remove("section-animated-enter");
			document
				.getElementById("section-8")
				.classList.add("section-animated-exit");
		},
		offset: 500,
	});
	var section5 = new Waypoint({
		element: sections[4],
		handler: function () {
			// console.log("Section 5 Has been Scrolled");
			header_buttons[0].classList.remove("highlighted");
			header_buttons[1].classList.remove("highlighted");
			header_buttons[2].classList.remove("highlighted");
			header_buttons[3].classList.remove("highlighted");
			header_buttons[4].classList.add("highlighted");
			header_buttons[5].classList.remove("highlighted");
			header_buttons[6].classList.remove("highlighted");
			header_buttons[7].classList.remove("highlighted");
			document
				.getElementById("section-1")
				.classList.remove("section-animated-enter");
			document
				.getElementById("section-1")
				.classList.add("section-animated-exit");
			document
				.getElementById("section-2")
				.classList.remove("section-animated-enter");
			document
				.getElementById("section-2")
				.classList.add("section-animated-exit");
			document
				.getElementById("section-3")
				.classList.remove("section-animated-enter");
			document
				.getElementById("section-3")
				.classList.add("section-animated-exit");
			document
				.getElementById("section-4")
				.classList.remove("section-animated-enter");
			document
				.getElementById("section-4")
				.classList.add("section-animated-exit");
			document
				.getElementById("section-5")
				.classList.add("section-animated-enter");
			document
				.getElementById("section-5")
				.classList.remove("section-animated-exit");
			document
				.getElementById("section-6")
				.classList.remove("section-animated-enter");
			document
				.getElementById("section-6")
				.classList.add("section-animated-exit");
			document
				.getElementById("section-7")
				.classList.remove("section-animated-enter");
			document
				.getElementById("section-7")
				.classList.add("section-animated-exit");
			document
				.getElementById("section-8")
				.classList.remove("section-animated-enter");
			document
				.getElementById("section-8")
				.classList.add("section-animated-exit");
		},
		offset: 500,
	});
	var section6 = new Waypoint({
		element: sections[5],
		handler: function () {
			// console.log("Section 6 Has been Scrolled");
			header_buttons[0].classList.remove("highlighted");
			header_buttons[1].classList.remove("highlighted");
			header_buttons[2].classList.remove("highlighted");
			header_buttons[3].classList.remove("highlighted");
			header_buttons[4].classList.remove("highlighted");
			header_buttons[5].classList.add("highlighted");
			header_buttons[6].classList.remove("highlighted");
			header_buttons[7].classList.remove("highlighted");
			document
				.getElementById("section-1")
				.classList.remove("section-animated-enter");
			document
				.getElementById("section-1")
				.classList.add("section-animated-exit");
			document
				.getElementById("section-2")
				.classList.remove("section-animated-enter");
			document
				.getElementById("section-2")
				.classList.add("section-animated-exit");
			document
				.getElementById("section-3")
				.classList.remove("section-animated-enter");
			document
				.getElementById("section-3")
				.classList.add("section-animated-exit");
			document
				.getElementById("section-4")
				.classList.remove("section-animated-enter");
			document
				.getElementById("section-4")
				.classList.add("section-animated-exit");
			document
				.getElementById("section-5")
				.classList.remove("section-animated-enter");
			document
				.getElementById("section-5")
				.classList.add("section-animated-exit");
			document
				.getElementById("section-6")
				.classList.add("section-animated-enter");
			document
				.getElementById("section-6")
				.classList.remove("section-animated-exit");
			document
				.getElementById("section-7")
				.classList.remove("section-animated-enter");
			document
				.getElementById("section-7")
				.classList.add("section-animated-exit");
			document
				.getElementById("section-8")
				.classList.remove("section-animated-enter");
			document
				.getElementById("section-8")
				.classList.add("section-animated-exit");
		},
		offset: 500,
	});
	var section7 = new Waypoint({
		element: sections[6],
		handler: function () {
			// console.log("Section 7 Has been Scrolled");
			header_buttons[0].classList.remove("highlighted");
			header_buttons[1].classList.remove("highlighted");
			header_buttons[2].classList.remove("highlighted");
			header_buttons[3].classList.remove("highlighted");
			header_buttons[4].classList.remove("highlighted");
			header_buttons[5].classList.remove("highlighted");
			header_buttons[6].classList.add("highlighted");
			header_buttons[7].classList.remove("highlighted");
			document
				.getElementById("section-1")
				.classList.remove("section-animated-enter");
			document
				.getElementById("section-1")
				.classList.add("section-animated-exit");
			document
				.getElementById("section-2")
				.classList.remove("section-animated-enter");
			document
				.getElementById("section-2")
				.classList.add("section-animated-exit");
			document
				.getElementById("section-3")
				.classList.remove("section-animated-enter");
			document
				.getElementById("section-3")
				.classList.add("section-animated-exit");
			document
				.getElementById("section-4")
				.classList.remove("section-animated-enter");
			document
				.getElementById("section-4")
				.classList.add("section-animated-exit");
			document
				.getElementById("section-5")
				.classList.remove("section-animated-enter");
			document
				.getElementById("section-5")
				.classList.add("section-animated-exit");
			document
				.getElementById("section-6")
				.classList.remove("section-animated-enter");
			document
				.getElementById("section-6")
				.classList.add("section-animated-exit");
			document
				.getElementById("section-7")
				.classList.add("section-animated-enter");
			document
				.getElementById("section-7")
				.classList.remove("section-animated-exit");
			document
				.getElementById("section-8")
				.classList.remove("section-animated-enter");
			document
				.getElementById("section-8")
				.classList.add("section-animated-exit");
		},
		offset: 500,
	});

	var section8 = new Waypoint({
		element: sections[7],
		handler: function () {
			// console.log("Section 8 Has been Scrolled");
			header_buttons[0].classList.remove("highlighted");
			header_buttons[1].classList.remove("highlighted");
			header_buttons[2].classList.remove("highlighted");
			header_buttons[3].classList.remove("highlighted");
			header_buttons[4].classList.remove("highlighted");
			header_buttons[5].classList.remove("highlighted");
			header_buttons[6].classList.remove("highlighted");
			header_buttons[7].classList.add("highlighted");
			document
				.getElementById("section-1")
				.classList.remove("section-animated-enter");
			document
				.getElementById("section-1")
				.classList.add("section-animated-exit");
			document
				.getElementById("section-2")
				.classList.remove("section-animated-enter");
			document
				.getElementById("section-2")
				.classList.add("section-animated-exit");
			document
				.getElementById("section-3")
				.classList.remove("section-animated-enter");
			document
				.getElementById("section-3")
				.classList.add("section-animated-exit");
			document
				.getElementById("section-4")
				.classList.remove("section-animated-enter");
			document
				.getElementById("section-4")
				.classList.add("section-animated-exit");
			document
				.getElementById("section-5")
				.classList.remove("section-animated-enter");
			document
				.getElementById("section-5")
				.classList.add("section-animated-exit");
			document
				.getElementById("section-6")
				.classList.remove("section-animated-enter");
			document
				.getElementById("section-6")
				.classList.add("section-animated-exit");
			document
				.getElementById("section-7")
				.classList.remove("section-animated-enter");
			document
				.getElementById("section-7")
				.classList.add("section-animated-exit");
			document
				.getElementById("section-8")
				.classList.add("section-animated-enter");
			document
				.getElementById("section-8")
				.classList.remove("section-animated-exit");
		},
		offset: 500,
	});
	sleep(500);
}
